import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import "./UserIndex.css";
import {Input, InputGroup, InputGroupText, Label} from "reactstrap";
import TextLabel from "../../../controls/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";
import UserSendOtp from "./UserSendOtp.mjs";
import UserVerifyOtp from "./UserVerifyOtp.mjs";
import UserActive from "./UserActive.mjs";
import UserDeletion from "./UserDeletion.mjs";
import MyAds from "./MyAds.mjs";

const prefix = "UserIndex";

const UserIndex = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			persist: Glob.storageCanPersist(),
			user: appLib.currentUser(),
			lang: Glob.getLanguage()
		};
		this.uid = Glob.generateUid(prefix);
		this.pane = this.pane.bind(this);
	}
	componentDidMount() {
		Glob.register('currentUser', ui => {
			this.setState({user: ui});
		}, this.uid);
		Glob.register('otp_sent', x => {
			this.setState({otp_sent: x});
		}, this.uid);
		Glob.register('my_user_deletion', x => {
			this.setState({my_user_deletion: x});
		}, this.uid);
		Glob.register('my_user_messages', x => {
			this.setState({my_user_messages: x});
		}, this.uid);
	}
	componentWillUnmount() {
		Glob.deregister( this.uid);
	}
	pane() {
		if ( ! this.state.user ) {
			if ( ! this.state.otp_sent ) return <UserSendOtp />;
			return <UserVerifyOtp />;
		}
		if ( this.state.my_user_deletion ) return <UserDeletion />;
		return <UserActive />;
	}
	render() {
		return(
			this.state.my_user_messages ? <MyAds /> : (
				<div className={prefix}>
					{ this.pane() }
					<hr />
					<div className={`${prefix}-persistence`}>
						<InputGroup>
							<InputGroupText>
								<Input
									id={'persist-'+this.uid}
									type="checkbox"
									value={1}
									checked={ this.state.persist }
									onChange={ ()=>{
										Glob.setStoragePersistence( ! this.state.persist );
										this.setState({persist: ! this.state.persist});
									}}
								/>
							</InputGroupText>
							<InputGroupText>
								<Label htmlFor={'persist-'+this.uid}>
									<TextLabel value={"Remember me"} />
								</Label>
							</InputGroupText>
						</InputGroup>
						{ this.state.persist ? (
							this.state.lang === 'it' ? (
								<p>
									Questo dispositivo è per il mio uso esclusivo:<br />
									non dovrò fare login ogni volta.
								</p>
							) : (
								<p>
									This is my own private device:<br />
									my login will be preserved among sessions.
								</p>
							)
						) : (
							this.state.lang === 'it' ? (
								<p>
									Questo dispositivo è pubblico o condiviso:<br />
									il login sarà perso alla chiusura del browser.
								</p>
							) : (
								<p>
									This is a shared or public device:<br />
									login is lost when quitting the browser.
								</p>
							)
						) }
					</div>
				</div>
			)
		)
	}
}

export default UserIndex;